export default "__VITE_ASSET__ed759079__"